<template>
  <div>
    <sc-rich-text
      tag="div"
      class="scrollable"
      v-if="fields && fields.table"
      :field="fields.table"
    />
    <sc-rich-text v-if="fields && fields.endCopy" :field="fields.endCopy" />
  </div>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Checkmark-Table',
  components: {
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
div {
  &:deep() {
    .scrollable {
      @include tablet-down {
        max-width: 100vw;
        overflow-x: auto;
        overflow-y: auto;
        position: relative;
      }

      table {
        width: 100%;
        margin: 5rem 0 1.5rem 0;

        @include tablet-down {
          border-collapse: collapse;
          table-layout: fixed;
        }
      }

      td {
        text-align: center;
        border-left: dashed 0.15rem $divider;
        width: calc((100% - 31.3%) / 4);
        padding: 1.5rem;

        @include tablet-down {
          width: 10rem;
          padding: 1.5rem 1rem;
        }

        &:last-child {
          border-right: solid 0.1rem $box-gray;
        }

        img {
          width: 2rem;
          height: 2rem;
        }

        &:first-child {
          width: 31.3%;
          padding: 1.5rem 2.4rem 1.5rem 1.6rem;
          text-align: left;
          border-left: solid 0.1rem $box-gray;
          @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);

          @include tablet-down {
            position: -webkit-sticky;
            position: sticky;
            left: -0.2rem;
            z-index: 2;
            width: 13rem;
            background-color: $white !important;
            font-size: 1.4rem;
            line-height: 2rem;
            padding: 1.5rem 1rem 1.5rem 1rem;
          }
        }
      }

      tr {
        &:first-child {
          td {
            position: relative;
            background-color: $box-gray;
            border-left: solid 0.1rem $box-gray;
            @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $dark-blue);

            @include tablet-up {
              @include font-styles('Arial', 2rem, 500, normal, 2.6rem, 0, $dark-blue);
              padding: 2.5rem 1rem;
            }

            &:before {
              content: '';
              display: block;
              width: calc(100% + 0.1rem);
              background-color: $orange;
              height: 0.5rem;
              position: absolute;
              top: -0.5rem;
              left: -0.1rem;
            }

            &:first-child {
              background-color: transparent;
              border-left: none;
              @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);

              @include tablet-up {
                @include font-styles('Arial', 2.8rem, 200, normal, 3.5rem, 0, $dark-blue);
                padding: 1.5rem 2.4rem 1.5rem 1.6rem;
              }

              @include tablet-down {
                position: -webkit-sticky;
                position: sticky;
                font-size: 2rem;
                line-height: 2.6rem;
                background: none;
                -webkit-text-fill-color: initial;
              }

              &:before {
                height: 0.8rem;
                background-color: $white;
                top: -0.7rem;
              }
            }

            &:last-child {
              border-right: none;
            }
          }
        }

        &:nth-child(2) {
          td {
            border-top: solid 0.1rem $box-gray;
          }
        }

        &:last-child {
          td {
            border-bottom: solid 0.1rem $box-gray;
          }
        }
      }
    }
  }
}
</style>
